<template>
  <li>{{ displayMessage }}</li>
</template>
<script>
export default {
  name: 'ValidationMessages',
  props: {
    message: {
      type: Object,
      required: true
    }
  },
  computed: {
    displayMessage () {
      let key = ''
      const keysToTry = [
        `${this.message.translationNameSpace}.validation.${this.message.propertyPath}.${this.message.code}`,
        `${this.message.translationNameSpace}.validation.${this.message.propertyPath}`,
        `${this.message.translationNameSpace}.validation.${this.message.code}`
      ]
      keysToTry.some(keyToTry => {
        key = keyToTry
        return this.$te(keyToTry)
      })
      return this.$t(key)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/forms/ValidationMessage.vue